type appNames = 'Advocate Central' | 'CASSI';

const appNameMap = new Map<string, appNames>([
  ['ac', 'Advocate Central'],
  ['cassi', 'CASSI'],
]);

export const appName: appNames | undefined = appNameMap.get(process.env.APP_NAME ?? '');
